export type PrimitiveType = 
  | 'OPSEC'
  | 'PublicAffairs'
  | 'Intel'
  | 'EW'
  | 'TechnicalActivities'
  | 'DeceptiveActivities'
  | 'PsyOp';

export interface PrimitiveDefinition {
  id: PrimitiveType;
  name: string;
  description: string;
  order: number;
  requiredScore: number; // Score needed to unlock next level (0-100)
  associatedActions: string[]; // ActionTypes associated with this primitive
}

export interface ProgressionState {
  unlockedPrimitives: PrimitiveType[];
  primitiveScores: Record<PrimitiveType, number>;
  currentPrimitive: PrimitiveType | null; // The primitive currently being trained
  level2Completions: number;
  isLevel2Unlocked: boolean;
  isLevel3Unlocked: boolean;
}

export const PRIMITIVE_ORDER: PrimitiveType[] = [
  'OPSEC',
  'PublicAffairs',
  'Intel',
  'EW',
  'TechnicalActivities',
  'DeceptiveActivities',
  'PsyOp'
];

export const PRIMITIVE_DEFINITIONS: Record<PrimitiveType, PrimitiveDefinition> = {
  'OPSEC': {
    id: 'OPSEC',
    name: 'Operations Security',
    description: 'Protect critical information from adversary observation.',
    order: 1,
    requiredScore: 85,
    associatedActions: ['Secure']
  },
  'PublicAffairs': {
    id: 'PublicAffairs',
    name: 'Public Affairs',
    description: 'Inform domestic and international audiences to build credibility.',
    order: 2,
    requiredScore: 85,
    associatedActions: ['Broadcast']
  },
  'Intel': {
    id: 'Intel',
    name: 'Intelligence',
    description: 'Listen and understand the environment to gain situational awareness.',
    order: 3,
    requiredScore: 85,
    associatedActions: ['Listen']
  },
  'EW': {
    id: 'EW',
    name: 'Electronic Warfare',
    description: 'Disrupt, degrade, or deny adversary communications.',
    order: 4,
    requiredScore: 85,
    associatedActions: ['Jam']
  },
  'TechnicalActivities': {
    id: 'TechnicalActivities',
    name: 'Technical Activities',
    description: 'Non-kinetic technical actions to affect infrastructure.',
    order: 5,
    requiredScore: 85,
    associatedActions: ['DeployTech', 'Hack']
  },
  'DeceptiveActivities': {
    id: 'DeceptiveActivities',
    name: 'Deceptive Activities',
    description: 'Mislead the adversary about your intentions and capabilities.',
    order: 6,
    requiredScore: 85,
    associatedActions: ['Decoy']
  },
  'PsyOp': {
    id: 'PsyOp',
    name: 'Psychological Operations',
    description: 'Influence the behavior of foreign target audiences.',
    order: 7,
    requiredScore: 85,
    associatedActions: ['Influence', 'Rally']
  }
};
